import { jsx as _jsx } from "react/jsx-runtime";
import SkeletonLoader from 'syf-component-library/ui/atoms/Loader/Skeleton/SlideInModalLoader';
import { Inset } from 'syf-component-library/ui/spacing';
const Loader = () => (_jsx(Inset, { horizontal: "large", "data-testid": "loading-indicator", children: _jsx(SkeletonLoader, {}) }));
export default Loader;
//# sourceMappingURL=index.js.map